import { NgModule } from '@angular/core';
import { TreeService } from './tree.service';
import { CheckBoxTreeComponent } from './checkbox-tree.component';
import { CheckboxTreeTemplateComponent } from './checkbox-tree-template.component';
import { CheckboxIndeterminateComponent } from './checkbox-tree-indeterminate.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

const components = [
  CheckBoxTreeComponent,
  CheckboxTreeTemplateComponent,
  CheckboxIndeterminateComponent
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [CommonModule, FormsModule],
  providers: [TreeService],
  exports: [...components]
})

export class CheckboxTreeModule { }
